import { PlayerColor, PlayerId } from "$types/index"

export const playerIcons: {
  [key in PlayerId]: PlayerColor
} = {
  1: "white",
  2: "black",
  3: "blue",
  4: "red"
}
